import { TFunction } from 'i18next'

export const DOUGHNUT_CHART_COLORS = ['#7978EB', '#AA32DE', '#EE8E00', '#EAE9E9', '#28B1A1']

export const getDoughnutSubtypeLabels = (
  t: TFunction<['communication']>,
): Record<string, string[]> => ({
  smiley: [
    t('communication:surveyDetails.charts.subtypeLabels.negative'),
    t('communication:surveyDetails.charts.subtypeLabels.neutral'),
    t('communication:surveyDetails.charts.subtypeLabels.good'),
    t('communication:surveyDetails.charts.subtypeLabels.awesome'),
  ],
  stars: [
    t('communication:surveyDetails.charts.subtypeLabels.veryNegative'),
    t('communication:surveyDetails.charts.subtypeLabels.negative'),
    t('communication:surveyDetails.charts.subtypeLabels.neutral'),
    t('communication:surveyDetails.charts.subtypeLabels.good'),
    t('communication:surveyDetails.charts.subtypeLabels.awesome'),
  ],
  thumbs: [
    t('communication:surveyDetails.charts.subtypeLabels.negative'),
    t('communication:surveyDetails.charts.subtypeLabels.positive'),
  ],
})
